/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { css, jsx } from '@emotion/react'

const billingResponsivePanelCss = css`
  overflow: auto;

  .euiTableHeaderMobile {
    display: none;
  }

  .euiTable {
    min-width: 700px;

    // nested tables
    .euiTable {
      min-width: auto;
      width: '100%';
    }
  }
`

interface Props {
  children: JSX.Element
}

const ResponsivePanelWrapper = ({ children }: Props): JSX.Element => (
  <div css={billingResponsivePanelCss}>{children}</div>
)

export default ResponsivePanelWrapper
